import * as React from 'react';
import { styled } from 'styled-components';

import { Skeleton, tk, Typography } from '@sunwebgroup/ui-components';

import { useIntl } from '@/intl';
import { useResults } from '@/scopes/search/search/domain/hooks';
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints';

interface ResultsCounterProps {
  isLoading?: boolean;
}

export function ResultsCounter({ isLoading }: ResultsCounterProps) {
  const intl = useIntl();
  const { isMobile } = useBreakpoints();
  const { totalResults } = useResults();

  if (isLoading) {
    return <Skeleton />;
  }

  const totalResultsText = isMobile
    ? intl.formatMessage({ id: 'search_results_sun' }, { nrOfResults: totalResults })
    : totalResults;

  return (
    <Text $variant="body-lg-bold" data-qa="total-results">
      {totalResultsText}
    </Text>
  );
}

const Text = styled(Typography)`
  color: ${tk('color_semantic_text_strong')};
`;
